import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import parse from 'html-react-parser';
import { useHistory, useParams, useRouteMatch } from "react-router-dom";
import InfiniteScroll from 'react-infinite-scroll-component';

import { setPageClass, setUpHeader } from "../../store/features/slice-ui";
import { renderMore, resetRender } from "../../store/features/slice-doctors";
import Section from "../../components/Section";
import PageHead from "../../components/PageHead";
import PageContent from "../../components/PageContent";
import DoctorCard from "../../components/Cards/Doctor";
import DoctorsFilter from "../../components/Filters/DoctorsFilter";
import ScrollToTop from '../../components/ScrollToTop';
import Loading from "../../components/Loading";

import G from "../../app/globals";

const DoctorsList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const match = useRouteMatch();
  let { page } = useParams();
  let section = match.url.indexOf("/discuss-patient") > -1 ? 'dp' : 'doctors'
  const [FilterOpen, setFilterOpen] = useState(true);
  const accountData = useSelector((state) => state.account.data);
  const doctorsIDs = useSelector((state) => state.doctors.list[section]);
  const doctorsListBasic = useSelector((state) => state.doctors.basic);
  const currentLoaded = useSelector((state) => state.doctors.currentLoaded[section]);
  const filters = useSelector((state) => state.doctors.filters[section]);
  const breakPoint = useSelector((state) => state.ui.breakPoint);
  const isDesktop = !G.TABLET_BREAKPOINTS.includes(breakPoint);
  const isFiltered = filters && (filters.special_interests || filters.fields || filters.locations || filters.doctor_name)
  useEffect(() => {
    dispatch(setPageClass("page-doctor-list"));
    dispatch(setUpHeader({
      show:true,
      back: true,
      profile: true,
      search: true
    }));
  }, [dispatch]);

  useEffect(() => {
    //reset the rendered items when accessing page (exclude back btn (POP))
    if(history.action === 'PUSH'){
      dispatch(resetRender(section));
    }
  }, [dispatch, history.action, section]);

  const renderDoctorsCards = () => {
    return doctorsIDs && currentLoaded ? doctorsIDs.slice(0, currentLoaded).map(id => (
      doctorsListBasic[id] ? <DoctorCard
          key={id}
          slug={doctorsListBasic[id].slug}
          image={doctorsListBasic[id].profileImage}
          title={parse(doctorsListBasic[id].salutation+" "+doctorsListBasic[id].name)}
          subtitle={doctorsListBasic[id].tags && doctorsListBasic[id].tags.length > 0 ? doctorsListBasic[id].tags.map((tag, index) => index > 0 ? ', '+tag.name : tag.name)  : null}
          icon="chevron_right"
          centres={doctorsListBasic[id].centres}
          link={`/doctor/${id}`}
          isFavourite = {accountData && accountData.favourites.includes(doctorsListBasic[id].slug) ? true : false}
      /> : null
    )) : null;
  };

  const handleFilterIconClick = () => {
    if(isDesktop){
      setFilterOpen(!FilterOpen);
    }
    else{
      history.push(`${match.url.indexOf("/discuss-patient") > -1 ? '/discuss-patient' : '/doctors'}/filter`)
    }
  }
  return (
    <>
    <ScrollToTop />
    <PageHead 
      className="page-doctor-list--page-head"
      title={match.url.indexOf("/discuss-patient") > -1 ? 'Discuss a Patient' : 'Find a Doctor'}
      icon={page === 'search' ? 'filter' : null}
      iconText={isDesktop ? (FilterOpen ? 'Close' : 'Filter') : 'Filter'}
      Clicked={handleFilterIconClick}
      secondaryIcon={isFiltered ? 'check' : null}
    />
    <PageContent className="page-doctor-list--content">
    {isDesktop && page === 'search' ? 
        <DoctorsFilter 
          className={`page-doctor-list--filter in-page${FilterOpen ? '' : ' collapsed'}`}
          title="Search"
          filter={match.url.indexOf("/discuss-patient") > -1 ? 'dp' : 'doctors'}
        />
    : null}
    {doctorsIDs && doctorsIDs.length > 0 ? 
      <Section className="page-doctor-list--content-list">
          <InfiniteScroll
              dataLength={currentLoaded}
              next={() => dispatch(renderMore(section))}
              hasMore={(currentLoaded < doctorsIDs.length)}
              loader={<Loading />}
              scrollThreshold={0.7}
            >
              {renderDoctorsCards()}
            </InfiniteScroll>
      </Section> 
    : null}
    </PageContent>
    </> 
  );
};

export default DoctorsList;
